import { useSyncExternalStore } from "react";

const consumers = new Set();

function subscribe(callback) {
    consumers.add(callback);
    return () => consumers.delete(callback);
}

let oldSnapshot = {
    accessToken: '',
    refreshToken: '',
    isAuthenticated: false,
};

function getSnapshot() {
    const snapshot = {
        accessToken: tokenHandler.get('accessToken'),
        refreshToken: tokenHandler.get('refreshToken'),
        isAuthenticated: !!tokenHandler.get('accessToken') && !!tokenHandler.get('refreshToken'),
    };

    for(let key in snapshot) {
        if(snapshot[key] !== oldSnapshot[key]) {
            oldSnapshot = snapshot;
            break;
        }
    }

    return oldSnapshot;
}

export function useAuthStore() {
    return useSyncExternalStore(
        subscribe,
        getSnapshot
    )
}

export const tokenHandler = {
    get(name) {
        switch(name) {
            case 'accessToken':
                return localStorage.getItem('Token');
            case 'refreshToken':
                return document.cookie.split('; ').find(row => row.startsWith('refreshToken='))?.slice('refreshToken='.length) ?? null;
            default:
                throw new Error('Invalid token name');
        }
    },

    set(name, token) {
        switch(name) {
            case 'accessToken':
                localStorage.setItem('Token', token);
                break;
            case 'refreshToken':
                document.cookie = `refreshToken=${token}; path=/; max-age=604800;`;
                document.cookie = `refreshToken=${token}; path=/; max-age=604800; domain=optigrit.com; secure; samesite=lax`;
                break;
            default:
                throw new Error('Invalid token name');
        }

        consumers.forEach(callback => callback());
    },

    remove(name) {
        switch(name) {
            case 'accessToken':
                localStorage.removeItem('Token');
                break;
            case 'refreshToken':
                document.cookie = 'refreshToken=; max-age=0; path=/';
                document.cookie = `refreshToken=; path=/; max-age=0; domain=optigrit.com; secure; samesite=lax`;
                break;
            default:
                throw new Error('Invalid token name');
        }

        consumers.forEach(callback => callback());
    }
};